export default "__VITE_ASSET__CB$gAFnB__"